import { List, Typography, Box } from '@mui/material'
import AccordionTAG from '../../components/AccordionTAG'
import ReportsBoxItem from './ReportsBoxItem'
import ReportsListItem from './ReportsListItem'
import { IReport } from '../../store/reports/types'

// Deprecated! Use render instead!
const renderListView = (
  data: IReport[],
  viewType: string,
  title: string,
  id: string,
  error = false,
  loading = false
) => {
  const getTitle = (loading: any) => {
    
    if (id !== 'immediate') {
      return (
        <Typography variant='h4'>
          {title} ({!loading ? data.length : 'Loading'})
        </Typography>
      )
    }
    return `${title} (${!loading ? data.length : 'Loading'})`
  }
  return (
    <div id={id}>
      <AccordionTAG
        boxError={error}
        title={getTitle(loading)}
        variant={viewType === 'box' ? 'accordionNormal' : 'accordionOutlined'}
      >
        {!loading && <List>
          {data.map((report, index) => {
            return <ReportsListItem report={report} key={`${report.uuid}${report.name} ${index}`} />
          })}
        </List>}
      </AccordionTAG>
    </div>
  )
}

// Deprecated! Use render instead!
const renderBoxView = (
  data: IReport[],
  viewType: string,
  title: string,
  id: string,
  error = false,
  loading = false
) => {
  const getTitle = (loading: any) => {
    if (id !== 'immediate') {
      return (
        <Box>
        <Typography variant='h2'>
          {title} ({!loading ? data.length : 'Loading'})
        </Typography>
        </Box>
      )
    }
    return `${title} (${!loading ? data.length : 'Loading'})`
  }
  return (
    <div id={id}>
      <AccordionTAG
        boxError={error}
        title={getTitle(loading)}
        variant={viewType === 'box' ? 'accordionNormal' : 'accordionOutlined'}
      >
        {loading ? null : data.map((report, index) => {
          return (
            <ReportsBoxItem
              report={report}
              key={`${report?.uuid}${report?.name} ${index}`}
              error={error}
            />
          )
        })}
      </AccordionTAG>
    </div>
  )
}

const render = (data: IReport[], viewType: string, title: string, id: string, error = false, loading = false) => {
  switch (viewType) {
    case 'box':
      return (
        <div id={id}>
          <AccordionTAG
            boxError={error}
            title={`${title} (${!loading ? data.length : 'Loading'})`}
            variant={'accordionNormal'}
          >
            {loading ? null :data.map((report, index) => {
              return (
                <ReportsBoxItem
                  report={report}
                  key={`${report.uuid}${report.name} ${index}`}
                  error={error}
                />
              )
            })}
          </AccordionTAG>
        </div>
      )
    case 'list':
      return (
        <div id={id}>
          <AccordionTAG
            boxError={error}
            title={`${title} (${!loading ? data.length : 'Loading'})`}
            variant={'accordionOutlined'}
          >
            {!loading && <List>
              {data.map((report, index) => {
                return (
                  <ReportsListItem report={report} key={`${report.uuid}${report.name} ${index}`} />
                )
              })}
            </List>}
          </AccordionTAG>
        </div>
      )
  }
}

export default {
  renderListView,
  renderBoxView,
  render,
}
